import Vue from 'vue'
import math from './libs/math'
import App from './App.vue'
import i18n from '@/lang/i18n'
import router from './router'
import store from './store'
import axios from './libs/axios'
import filter from './libs/filter'
import geturlkey from './libs/urlkey'
import './components'
import './style/reset.css'
import './style/index.css'

import './style/iview_replace.less'
import "swiper/dist/css/swiper.css";
import iView from 'iview';

Date.prototype.format = function(fmt) { 
  var o = { 
     "M+" : this.getMonth()+1,                 //月份 
     "d+" : this.getDate(),                    //日 
     "h+" : this.getHours(),                   //小时 
     "m+" : this.getMinutes(),                 //分 
     "s+" : this.getSeconds(),                 //秒 
     "q+" : Math.floor((this.getMonth()+3)/3), //季度 
     "S"  : this.getMilliseconds()             //毫秒 
 }; 
 if(/(y+)/.test(fmt)) {
         fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
 }
  for(var k in o) {
     if(new RegExp("("+ k +")").test(fmt)){
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      }
  }
 return fmt; 
}

Vue.config.productionTip = false
Vue.use(math)
Vue.use(iView)
Vue.use(axios)
Vue.use(filter)
Vue.prototype.$geturlkey = geturlkey

new Vue({
  render: h => h(App),
  router,
  store,
  i18n
}).$mount('#app')
